import React, {useMemo, useContext} from 'react';
import TextsContext from "../../contexts/Texts";

export const Text = React.memo(({code, tag, ...props}) => {
	const texts = useContext(TextsContext);
	const [Tag, containerProps] = useMemo(() => {
		if (tag) {
			return [tag, {...props}];
		}
		return [React.Fragment, {}];
	}, [tag, props]);

	return (
		<Tag {...containerProps}>
			{texts[code]}
		</Tag>
	);
});